module.exports = __webpack_public_path__ + "static/media/concretagem.7f7cf859.jpg";